import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectZandloper = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={10}
    height={14}
    viewBox='0 0 10 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M8.34676 11.9767H8.39676V11.967C8.58676 11.943 8.73009 11.784 8.73009 11.5867V9.6334C8.73009 9.05553 8.42055 8.519 7.91836 8.23007L7.91834 8.23006L5.76708 6.9934L7.91834 5.75675L7.91836 5.75674C8.42055 5.46781 8.73009 4.93128 8.73009 4.3534V2.40007C8.73009 2.18579 8.56104 2.01674 8.34676 2.01674H1.64676C1.43248 2.01674 1.26342 2.18579 1.26342 2.40007V4.3534C1.26342 4.93127 1.57296 5.4678 2.07514 5.75674C2.07515 5.75674 2.07515 5.75674 2.07516 5.75674L3.61514 6.6434L3.63984 6.65762L3.66467 6.64362L4.338 6.26362L4.41447 6.22046L4.33833 6.17672L2.45833 5.09672L2.45823 5.09666C2.19381 4.94556 2.03009 4.66213 2.03009 4.36007V2.79007H7.96342V4.36007C7.96342 4.66213 7.7997 4.94556 7.53528 5.09666L7.53516 5.09673L2.07516 8.23673L2.07516 8.23673C1.57297 8.52566 1.26342 9.0622 1.26342 9.64007V11.5934C1.26342 11.8077 1.43248 11.9767 1.64676 11.9767H8.34676ZM7.5352 8.90343L7.53528 8.90348C7.7997 9.05458 7.96342 9.33801 7.96342 9.64007V11.2101H2.02342V9.64007C2.02342 9.33801 2.18715 9.05458 2.45157 8.90348L2.45165 8.90343L4.99342 7.44439L7.5352 8.90343ZM9.23342 1.1234C9.4477 1.1234 9.61676 0.954353 9.61676 0.740072C9.61676 0.525791 9.4477 0.356738 9.23342 0.356738H0.760091C0.54581 0.356738 0.376758 0.525791 0.376758 0.740072C0.376758 0.954352 0.54581 1.1234 0.760091 1.1234H9.23342ZM9.23342 13.6434C9.44771 13.6434 9.61676 13.4744 9.61676 13.2601C9.61676 13.0458 9.4477 12.8767 9.23342 12.8767H0.760091C0.54581 12.8767 0.376758 13.0458 0.376758 13.2601C0.376758 13.4744 0.54581 13.6434 0.760091 13.6434H9.23342Z'
      stroke='#0A3680'
      strokeWidth={0.1}
    />
  </svg>
);
export default SvgDefectZandloper;
